import { TRootState }                                   from 'Redux/Reducers';
import { filterObjectStore, queryFilter, IFilterProps } from 'Utils';
import { EventParentCategory }                                from 'Domain/Models';

export const getEventParentCategories = (state: TRootState, filter: null | IFilterProps<EventParentCategory> = null) => {
  if (filter === null) {
    filter = queryFilter({ sorting: { by: 'name', order: 'ASC' } }) as IFilterProps<EventParentCategory>;
  }

  return filterObjectStore(state.eventParentCategory.entries, filter);
};
